import cx from 'classnames';
import React from 'react';
import { Tooltip, TooltipWrapper, useTooltipState } from '../tooltip/index.js';
export const IconButton = ({ 'aria-label': ariaLabel, children, className, disabled, fullLabel, highlighted, label, size, tooltipProps, ...rest }) => {
    const { handlers, open, toggleExpanded, wrapperRef } = useTooltipState();
    // Only wrap the button in a tooltip if it has an explicit label and is enabled
    const enableTooltip = !disabled && (label || fullLabel);
    const button = (React.createElement("button", { "aria-label": ariaLabel || label, className: cx('tds-icon-btn', {
            'tds--highlighted': highlighted,
            [`tds-icon-btn--${size}`]: size,
        }, 
        // Pass classname here if the outer tooltipWrapper isn't rendered
        !enableTooltip ? className : ''), disabled: disabled, type: "button", ...rest }, children));
    return enableTooltip ? (React.createElement(TooltipWrapper, { className: className, ...handlers, inline: true, onClick: toggleExpanded, wrapperRef: wrapperRef },
        button,
        React.createElement(Tooltip, { dense: true, open: !disabled && open, ...tooltipProps }, fullLabel || label))) : (button);
};
